import React from "react";

export default function VideoPlayOverlay({ size = "large", onClick }) {
    const isSmall = size === "small";
    const dim = isSmall ? 44 : 56;
    const svgSize = isSmall ? 18 : 24;

    const containerStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: dim,
        height: dim,
        backgroundColor: "rgba(0,0,0,0.6)",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: onClick ? "pointer" : "default",
    };

    return (
        <div
            role="button"
            aria-label="Play video"
            onClick={onClick}
            style={containerStyle}
        >
            <svg
                width={svgSize}
                height={svgSize}
                viewBox="0 0 24 24"
                fill="white"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M8 5v14l11-7z" />
            </svg>
        </div>
    );
}
